import apiClient from "@/utils/axios";
import { ApiResponse } from "@/interfaces/api-response";
import { User } from "@/interfaces/user.interface";
import { useToastStore } from "@/stores/toast.store";
import axios, { AxiosError } from "axios";

interface ErrorResponse {
  message?: string;
  error?: string;
}

const login = async (
  email: string,
  password: string,
): Promise<{
  access_token: string;
  refresh_token: string;
  user: User;
} | null> => {
  try {
    const response = await axios.post(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/v1/auth/login`,
      { email, password },
    );
    return response.data.data;
  } catch (error) {
    const errorData = (error as AxiosError).response?.data as ErrorResponse;
    const message =
      errorData?.message ||
      errorData?.error ||
      (error as AxiosError).message ||
      "Something went wrong";
    useToastStore.getState().showToast("error", "Login failed", message);
    return null;
  }
};

const refreshToken = async (token: string): Promise<string | null> => {
  try {
    const response = await axios.post(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/v1/auth/refresh`,
      { refreshToken: token },
    );
    return response.data?.data?.access_token ?? null;
  } catch {
    return null;
  }
};

const logout = async (): Promise<void> => {
  try {
    await apiClient.post("/auth/logout");
  } catch {
    // ignore
  }
};

const changePassword = async (data: {
  email: string;
  oldPassword: string;
  newPassword: string;
}) => {
  const response = await axios.post<ApiResponse<null>>(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/v1/auth/change-password`,
    data,
  );
  return response.data;
};

const authApi = {
  login,
  refreshToken,
  logout,
  changePassword,
};

export default authApi;
